<template>
  <div>
    <!-- productivity_area  -->
    <div class="productivity_area">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-7 col-md-12 col-lg-6">
            <h3 class="wow fadeInDown" data-wow-duration="1s" data-wow-delay=".1s">
              Get start from now
              <br />and increase productivity
            </h3>
          </div>
          <div class="col-xl-5 col-md-12 col-lg-6">
            <div class="app_download wow fadeInDown" data-wow-duration="1s" data-wow-delay=".1s">
              <!-- <a href="#">
                <img src="@/assets/img/ilstrator/app.svg" alt />
              </a> -->
              <a href="#">
                <img src="@/assets/img/ilstrator/play.svg" alt />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ productivity_area  -->
    <!-- footer start -->
    <footer class="footer">
      <div class="footer_top">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-md-6 col-lg-4">
              <div class="footer_widget">
                <div class="footer_logo">
                  <a href="#">
                    <img src="img/logo.png" alt />
                  </a>
                </div>
                <p>
                  Find More Places With City Guider
                </p>
                <div class="socail_links">
                  <ul>
                    <li>
                      <a href="#">
                        <i class="ti-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="ti-twitter-alt"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="fa fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-xl-2 offset-xl-1 col-md-6 col-lg-3">
              <div class="footer_widget">
                <h3 class="footer_title">Services</h3>
                <ul>
                  <li>
                    <a href="#">Weather Forecast</a>
                  </li>
                  <li>
                    <a href="#">Tourism</a>
                  </li>
                  <li>
                    <a href="#">Place Finder</a>
                  </li>
                  <li>
                    <a href="#">Directions</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-2 col-md-6 col-lg-2">
              <div class="footer_widget">
                <h3 class="footer_title">Useful Links</h3>
                <ul>
                  <li>
                    <a href="#">Features</a>
                  </li>
                  <li>
                    <a href="#">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-3 col-md-6 col-lg-3">
              <div class="footer_widget">
                <h3 class="footer_title">Downloads</h3>
                <ul>
                  <!-- <li>
                    <a href="#">Download from Apple Store</a>
                  </li> -->
                  <li>
                    <a href="#">Download from Play Store</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copy-right_text">
        <div class="container">
          <div class="footer_border"></div>
          <div class="row">
            <div class="col-xl-12">
              <p class="copy_right text-center">
                Copyright &copy;
                {{currentYear}}
                | Developed
                <i
                  class="fa fa-heart-o"
                  aria-hidden="true"
                ></i> by
                <a href="http://alkarimtech.com/" target="_blank">Al Karim Tech</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!--/ footer end  -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>
<style>
</style>